@if (isLoaded) {
  <div class="layout-container">
    <app-credential-header
      [headerBackground]="headerBackground"
      [headerTextColor]="headerTextColor"
      [logoCampaign]="logoCampaign"
    >
    </app-credential-header>

    <main class="layout-content">
      <router-outlet></router-outlet>
    </main>
    <app-credential-footer
      [logoCampaign]="logoCampaign"
      [footerBackground]="footerBackground"
      [footerTextColor]="footerTextColor"
    >
    </app-credential-footer>
  </div>
} @else {
  <div class="sw-loader-wrapper fade show">
    <img class="sw-logo" src="assets/img/favicon.png" alt="ShareWave" />
    <div class="sw-loader-bar">
      <div class="sw-loader-progress"></div>
    </div>
    <div class="sw-loading-text">Cargando</div>
  </div>
}
